// PDF React View
import { yupResolver } from "@hookform/resolvers/yup";
import { ISSUE_INVOICE_HHDV_FIELD } from "constants/IssueInvoiceConstant";
import {
  generateInputFieldArray,
  generateSelectFieldArray,
} from "helpers/form_helper_new";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as yup from "yup";
import "./SpecializationGoodsModal.scss";

const SpecializationGoodsModal = props => {
  const dispatch = useDispatch();
  const { isOpen, toggle, onUpdateHandle, dataDefault, isDisable } = props;

  const SPECIALIZATION_GOODS_FIELD =
    ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.TTHHDTRUNG;

  const LHHDTrung = SPECIALIZATION_GOODS_FIELD.list.LHHDTrung;
  const TTruong = SPECIALIZATION_GOODS_FIELD.list.TTruong;
  const DLieu = SPECIALIZATION_GOODS_FIELD.list.DLieu;

  const schema = yup.object().shape({
    [SPECIALIZATION_GOODS_FIELD.field]: yup.array().of(
      yup.object().shape({
        [LHHDTrung.field]: yup.object().nullable().required("Vui lòng chọn"),
        [TTruong.field]: yup
          .object()
          .required("Vui lòng chọn")
          .nullable()
          // not allow dulicate
          .test(
            "is-not-duplicate",
            "Tên trường không được trùng nhau",
            value => {
              const listHHDV = getValues(SPECIALIZATION_GOODS_FIELD.field);
              const keyLength = listHHDV.filter(
                item => item[TTruong.field] === value
              ).length;
              if (keyLength > 1) {
                return false;
              }
              return true;
            }
          ),
        [DLieu.field]: yup.string().required("Vui lòng chọn"),
      })
    ),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      [SPECIALIZATION_GOODS_FIELD.field]: [],
    },
  });

  const defaultValueLine = {
    [LHHDTrung.field]: LHHDTrung.options[0],
    [TTruong.field]: LHHDTrung.options[0]?.data[0],
    [DLieu.field]: "",
  };

  const {
    fields: fieldsHHDV,
    append: appendHHDV,
    remove: removeHHDV,
    replace: replaceHHDV,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: SPECIALIZATION_GOODS_FIELD.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  const addNewLineHHDV = () => {
    const listHHDV = getValues(SPECIALIZATION_GOODS_FIELD.field);
    const firstItem = listHHDV?.[0];
    if (firstItem) {
      appendHHDV({
        [LHHDTrung.field]: firstItem[LHHDTrung.field],
        [TTruong.field]: null,
        [DLieu.field]: "",
      });
    } else {
      appendHHDV(defaultValueLine);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setValue(SPECIALIZATION_GOODS_FIELD.field, [...dataDefault]);
    } else {
      setValue(SPECIALIZATION_GOODS_FIELD.field, []);
    }
  }, [isOpen, JSON.stringify(dataDefault)]);

  const onSubmit = data => {
    onUpdateHandle(data?.[SPECIALIZATION_GOODS_FIELD.field]);
  };

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ errors:", errors);
  }, [errors]);

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content SpecializationGoodsModal">
        <ModalHeader toggle={toggle}>
          <Label>Thông tin loại hàng hóa đặc trưng</Label>
        </ModalHeader>

        <React.Fragment>
          <ModalBody>
            <React.Fragment>
              {!isDisable && (
                <div className="d-flex justify-content-end">
                  <Button color="primary" onClick={addNewLineHHDV}>
                    Thêm hàng hóa
                  </Button>
                </div>
              )}
              <Row className="row-cols-1">
                <Col
                  className="text-center text-info"
                  style={{ borderRight: "1px solid #8080805c" }}
                >
                  <table className="table ">
                    <thead>
                      <tr className="text-info">
                        <th scope="col">STT</th>
                        <th scope="col">Loại hàng hóa đặc trưng</th>
                        <th scope="col" style={{ width: "300px" }}>
                          Tên trường
                        </th>
                        <th scope="col">Dữ liệu</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {fieldsHHDV.map((item, index) => {
                        const watchLHHDTrung = watch(
                          `${SPECIALIZATION_GOODS_FIELD.field}.${index}.${LHHDTrung.field}`
                        );
                        const optionTTruong = watchLHHDTrung?.data || [];
                        return (
                          <tr key={item.key}>
                            <td>{index + 1}</td>
                            <td>
                              {generateSelectFieldArray({
                                watch: watch,
                                label: "",
                                isRequire: true,
                                errors: errors,
                                fieldArray: SPECIALIZATION_GOODS_FIELD.field,
                                index: index,
                                fieldChild: LHHDTrung.field,
                                placeholder: "",
                                disabled: isDisable || index !== 0,
                                control: control,
                                options: LHHDTrung.options,
                                onChangeHandle: (
                                  fieldArray,
                                  index,
                                  fieldChild,
                                  selectedData
                                ) => {
                                  setValue(
                                    `${SPECIALIZATION_GOODS_FIELD.field}.${index}.${TTruong.field}`,
                                    selectedData?.data?.[0]
                                  );
                                  // Remove all item in listHHDV except first
                                  const listHHDV = getValues(
                                    SPECIALIZATION_GOODS_FIELD.field
                                  );
                                  const allIndexExcept0 = listHHDV
                                    .map((item, index) => index)
                                    .filter(val => val !== 0);
                                  console.log(
                                    "🚀 ~ {fieldsHHDV.map ~ allIndexExcept0:",
                                    allIndexExcept0
                                  );
                                  setTimeout(() => {
                                    removeHHDV(allIndexExcept0);
                                  }, 100);
                                },
                                menuPlacementSetting: "bottom",
                                allowCreate: false,
                              })}
                            </td>
                            <td>
                              {" "}
                              {generateSelectFieldArray({
                                watch: watch,
                                label: "",
                                isRequire: true,
                                errors: errors,
                                fieldArray: SPECIALIZATION_GOODS_FIELD.field,
                                index: index,
                                fieldChild: TTruong.field,
                                placeholder: "",
                                disabled: isDisable,
                                control: control,
                                options: optionTTruong,
                                onChangeHandle: () => {},
                                menuPlacementSetting: "bottom",
                                allowCreate: false,
                              })}
                              {errors?.[SPECIALIZATION_GOODS_FIELD.field]?.[
                                index
                              ]?.[TTruong.field] && (
                                <div className="text-danger">
                                  {
                                    errors?.[
                                      SPECIALIZATION_GOODS_FIELD.field
                                    ]?.[index]?.[TTruong.field]?.message
                                  }
                                </div>
                              )}
                            </td>
                            <td>
                              {generateInputFieldArray({
                                label: "",
                                isRequire: true,
                                inputType: "text",
                                errors: errors,
                                touched: touchedFields,
                                fieldArray: SPECIALIZATION_GOODS_FIELD.field,
                                index: index,
                                fieldChild: DLieu.field,
                                placeholder: "",
                                register: register,
                                disabled: isDisable,
                                setInputValueChange: () => {},
                                control: control,
                                watch: watch,
                              })}
                            </td>
                            {!isDisable && (
                              <td>
                                <Button
                                  color="danger"
                                  onClick={() => removeHHDV(index)}
                                >
                                  Xóa
                                </Button>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </React.Fragment>
          </ModalBody>
          <ModalFooter>
            {!isDisable && (
              <Button color="success" onClick={handleSubmit(onSubmit)}>
                Cập nhật
              </Button>
            )}
          </ModalFooter>
        </React.Fragment>
      </div>
    </Modal>
  );
};

SpecializationGoodsModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  onUpdateHandle: PropTypes.func,
  dataDefault: PropTypes.array,
  isDisable: PropTypes.bool,
};

export default SpecializationGoodsModal;
